import patterns from 'js/validationPatterns';

export function passesRequired(fieldNode) {
    return fieldNode.hasAttribute('required') ? hasValue(fieldNode) : true;
}

export function passesPattern(fieldNode) {
    return fieldNode.hasAttribute('data-pattern') && hasValue(fieldNode) ? hasValidPattern(fieldNode) : true;
}

export function passesMaxLength(fieldNode) {
    return fieldNode.hasAttribute('maxlength') && hasValue(fieldNode)
        ? fieldNode.value.length <= parseInt(fieldNode.getAttribute('maxlength'), 10)
        : true;
}

export function hasValue(fieldNode) {
    return patterns.required.test(fieldNode.value);
}

export function hasValidPattern(fieldNode) {
    const pattern = fieldNode.getAttribute('data-pattern');

    return patterns[pattern].test(fieldNode.value);
}

export function isValidField(fieldNode) {
    return passesRequired(fieldNode) && passesPattern(fieldNode) && passesMaxLength(fieldNode);
}

export function isCheckbox(fieldNode) {
    return fieldNode.tagName === 'INPUT' && fieldNode.getAttribute('type') === 'checkbox';
}
